import { fetchArticleList, fetchSale } from "shadow-client/endpoints/saleApi";
import { fetchFile } from "shadow-client/endpoints/fileApi";
import { fetchProduct } from "shadow-client/endpoints/productApi";

const fetchCart = saleId => (dispatch, getState) => {
  return Promise.all([dispatch(fetchSale(saleId)), dispatch(fetchArticleList({ params: { sale: saleId } }))]).then(
    ([saleResponse, articlesResponse]) => {
      const fetchProductPromiseList = articlesResponse["hydra:member"].map(article =>
        dispatch(fetchProduct(article.get("productId"))).then(productResponse => {
          return dispatch(
            fetchFile(productResponse.getIn(["publicMetadata", "imagePath"]), {
              headers: {
                Accept: "text/base64",
                "X-Accept-Encoding": "base64"
              }
            })
          );
        })
      );

      return Promise.all(fetchProductPromiseList);
    }
  );
};

export default fetchCart;



// WEBPACK FOOTER //
// ./src/app/redux/actions/fetchCart.js